import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Box } from "../../Box/index.js";
import { Label } from "../common/index.js";
import SwitchInput_styles from "./SwitchInput.styles.js";
const SwitchInput = (t0)=>{
    const $ = c(26);
    const { label, labelIcon, onChange, disabled: t1, labelPlacement: t2, checked, tooltip, testId } = t0;
    const disabled = void 0 === t1 ? false : t1;
    const labelPlacement = void 0 === t2 ? "start" : t2;
    const { classes } = SwitchInput_styles();
    let t3;
    if ($[0] !== classes.root) {
        t3 = {
            root: classes.root
        };
        $[0] = classes.root;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== classes.disabled || $[3] !== classes.switchBase || $[4] !== classes.switchRoot || $[5] !== classes.thumb || $[6] !== classes.track) {
        t4 = {
            root: classes.switchRoot,
            track: classes.track,
            switchBase: classes.switchBase,
            disabled: classes.disabled,
            thumb: classes.thumb
        };
        $[2] = classes.disabled;
        $[3] = classes.switchBase;
        $[4] = classes.switchRoot;
        $[5] = classes.thumb;
        $[6] = classes.track;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== onChange) {
        t5 = (event, check)=>{
            onChange(check);
        };
        $[8] = onChange;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== checked || $[11] !== disabled || $[12] !== t4 || $[13] !== t5 || $[14] !== testId) {
        t6 = /*#__PURE__*/ jsx(Switch, {
            checked: checked,
            disableRipple: true,
            classes: t4,
            color: "primary",
            disabled: disabled,
            onChange: t5,
            "data-testid": testId
        });
        $[10] = checked;
        $[11] = disabled;
        $[12] = t4;
        $[13] = t5;
        $[14] = testId;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== label || $[17] !== labelIcon || $[18] !== labelPlacement || $[19] !== tooltip) {
        t7 = label ? /*#__PURE__*/ jsx(Box, {
            mr: "start" === labelPlacement ? "16" : "0",
            ml: "end" === labelPlacement ? "16" : "0",
            mb: "-4",
            children: /*#__PURE__*/ jsx(Label, {
                label: label,
                tooltip: tooltip,
                icon: labelIcon
            })
        }) : null;
        $[16] = label;
        $[17] = labelIcon;
        $[18] = labelPlacement;
        $[19] = tooltip;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== labelPlacement || $[22] !== t3 || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ jsx(FormControlLabel, {
            classes: t3,
            control: t6,
            label: t7,
            labelPlacement: labelPlacement,
            className: "aqa_switch_input"
        });
        $[21] = labelPlacement;
        $[22] = t3;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
export { SwitchInput };
